import { combineReducers } from '@reduxjs/toolkit';

import stopFilters from './stopFilters';
import stopListOrder from './stopListOrder';
import selectedParcels from './selectedParcels';
import { CLEAR_ALL } from '../../../actions/ui/routeDetail';

// Combine reducers for route details
const routeDetails = combineReducers({
  stopFilters,
  stopListOrder,
  selectedParcels,
});

// Reducer with reset functionality
const routeDetailsReducer = (state, action) => {
  if (action.type === CLEAR_ALL) {
    // Reset the state to its initial state
    return routeDetails({}, action);
  }
  return routeDetails(state, action);
};

export default routeDetailsReducer;
